// CaseData.js
import { FiBarChart , FiUser ,FiDollarSign } from "react-icons/fi";
import { FaMobile ,FaClock,FaServer } from "react-icons/fa";
import CS1 from "../../Assets/CaseStudy/casestudy1.avif";
import CS2 from "../../Assets/CaseStudy/casestudy2.avif";

const caseStudies = [
  {
    id: 1,
    slug: "ecommerce-transformation",
    title: "E-commerce Platform Transformation",
    client: "ShopNation",
    industry: "Retail/E-commerce",
    duration: "6 months",
    budget: "$250,000",
    excerpt: "Revolutionized online shopping experience with 142% conversion boost",
    tags: ["E-commerce", "UX Design", "Performance"],
    coverImage: CS1,
    
    // Extra fields for details page
    challenge: "ShopNation was struggling with a 32% cart abandonment rate...",
    solution: "We implemented a complete redesign with React frontend...",
    results: [
      { metric: "142%", description: "Increase in conversion rate", icon: <FiBarChart/> },
      { metric: "68%", description: "Faster mobile load times", icon: <FaMobile/> },
      { metric: "3.2M", description: "Monthly active users", icon: <FiUser/> },
      { metric: "$4.8M", description: "Revenue growth in Q1", icon: <FiDollarSign/> }
    ],
    testimonial: {
      text: "The team completely transformed our digital presence...",
      author: "Sarah Johnson",
      role: "CEO, ShopNation",
      avatar: "/images/avatar-female.jpg"
    },
    gallery: [
      "/images/ecommerce-1.jpg",
      "/images/ecommerce-2.jpg"
    ]
  },
  {
    id: 2,
    slug: "cloud-modernization",
    title: "Cloud Infrastructure Modernization",
    client: "TechCorp",
    industry: "Technology",
    duration: "4 months",
    budget: "$180,000",
    excerpt: "Scalable cloud solutions reducing costs by 45%",
    tags: ["Cloud", "DevOps", "Scalability"],
    coverImage: CS2,
    
    challenge: "TechCorp's on-premise infrastructure was costly to maintain...",
    solution: "We migrated their infrastructure to a cloud-native architecture...",
    results: [
      { metric: "45%", description: "Reduction in operational costs", icon: <FiBarChart/>},
      { metric: "99.99%", description: "System uptime", icon: <FaServer/> },
      { metric: "3x", description: "Faster deployment speed", icon: <FaClock/> },
      { metric: "12", description: "Teams supported", icon: <FiUser/> }
    ],
    testimonial: {
      text: "The cloud migration was seamless and the results exceeded...",
      author: "Michael Chen",
      role: "CTO, TechCorp",
      avatar: "/images/avatar-male.jpg"
    },
    gallery: [
      "/images/cloud-1.jpg",
      "/images/cloud-2.jpg"
    ]
  }
];

export default caseStudies;
